var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComplianceLines = function SvgComplianceLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 432.782 484.209"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__a)",
    d: "M56.648 241.663c45.7 18.944 87.984 44.906 88.434 45.184.438.18 43.648 18.421 89.423 29.545 26.892 6.528 49.404 9.374 66.898 8.425 21.95-1.177 36.053-8.343 41.921-21.3 13.54-29.855 49.677-90.32-22.79-179.691-27.055-33.373-45.963-62.853-56.187-87.654-5.431-13.185-8.497-25.259-9.197-36.138h-.551c.701 10.994 3.779 23.198 9.273 36.482 10.261 24.866 29.194 54.427 56.299 87.85 72.254 89.109 36.093 149.263 22.703 178.792-5.769 12.727-19.722 19.778-41.458 20.94-17.444.932-39.919-1.898-66.773-8.409-45.738-11.108-88.923-29.333-89.323-29.513-.426-.261-42.734-26.24-88.472-45.201C35.137 231.978 16.09 225.958.06 223.029v.736c15.992 2.929 34.963 8.933 56.612 17.914z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__b)",
    d: "M58.662 249.712c45.349 17.816 87.195 42.796 87.658 43.058.426.18 43.435 17.407 89.048 27.369 26.804 5.857 49.241 8.082 66.71 6.626 21.899-1.816 36.015-9.488 41.946-22.772 13.578-30.412 50.64-90.157-20.037-177.565-26.229-32.44-44.537-61.282-54.435-85.723-6.057-14.97-9.06-28.58-9.022-40.686h-.551c-.037 12.237 2.991 25.962 9.085 41.03 9.923 24.506 28.269 53.413 54.547 85.902 70.465 87.163 33.378 146.597 19.95 176.682-13.239 29.659-66.085 24.964-108.068 15.787-45.575-9.947-88.56-27.173-88.948-27.337-.412-.245-42.296-25.242-87.683-43.074-22.625-8.883-42.346-14.527-58.79-16.867v.736c16.406 2.323 36.065 7.967 58.627 16.818z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__c)",
    d: "M60.541 257.726c45.024 16.687 86.457 40.686 86.908 40.948.425.164 43.272 16.408 88.747 25.194 26.717 5.169 49.104 6.789 66.548 4.826 21.862-2.471 35.989-10.634 41.984-24.261 13.602-30.952 51.578-89.994-17.335-175.488-25.403-31.524-43.135-59.712-52.708-83.776-6.645-16.736-9.485-31.852-8.522-45.136h-.563c-.963 13.415 1.902 28.645 8.585 45.463 9.598 24.146 27.367 52.4 52.82 83.973 68.7 85.232 30.699 143.979 17.235 174.604-13.378 30.444-66.098 27.173-107.956 19.091-45.438-8.785-88.247-25.013-88.635-25.161-.413-.245-41.896-24.261-86.945-40.964-23.476-8.703-43.836-13.938-60.654-15.607v.72c16.768 1.669 37.078 6.888 60.491 15.574"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__d)",
    d: "M62.28 265.709c44.712 15.574 85.769 38.608 86.207 38.854.426.147 43.122 15.41 88.485 23.034 26.654 4.482 49.003 5.48 66.422 2.994 21.837-3.125 35.977-11.795 42.022-25.766 13.614-31.492 52.491-89.846-14.682-173.426-24.602-30.609-41.759-58.158-51.019-81.863-7.195-18.47-9.773-35.074-7.696-49.503h-.563c-2.052 14.56.538 31.279 7.771 49.83 9.285 23.787 26.479 51.402 51.131 82.059 66.961 83.335 28.059 141.378 14.582 172.543-5.957 13.758-19.947 22.314-41.608 25.406-17.369 2.486-39.681 1.472-66.285-2.994-45.325-7.623-87.984-22.854-88.372-22.985-.413-.229-41.496-23.279-86.245-38.87-24.289-8.458-45.237-13.218-62.393-14.183v.736c17.094.965 38.004 5.709 62.243 14.151z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__e)",
    d: "M63.881 273.68c44.424 14.461 85.106 36.53 85.544 36.775.425.148 42.997 14.397 88.272 20.859 26.604 3.795 48.916 4.188 66.322 1.161 21.824-3.779 35.99-12.973 42.084-27.32 13.627-32.032 53.368-89.699-12.079-171.397-23.801-29.725-40.407-56.62-49.342-79.965-7.721-20.155-9.923-38.216-6.607-53.757h-.575c-3.304 15.672-1.064 33.848 6.682 54.084 8.972 23.427 25.603 50.387 49.454 80.161 65.234 81.454 25.456 138.826 11.979 170.531-6.007 14.134-20.035 23.197-41.671 26.943-17.369 3.011-39.631 2.618-66.185-1.161-45.237-6.446-87.771-20.695-88.159-20.809-.413-.213-41.12-22.314-85.581-36.793-25.04-8.147-46.551-12.367-63.983-12.613v.72c17.407.229 38.855 4.45 63.845 12.597z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__f)",
    d: "M65.37 281.628c44.148 13.35 84.492 34.47 84.93 34.699.426.131 42.91 13.398 88.122 18.666 26.566 3.092 48.853 2.863 66.273-.687 21.823-4.45 36.001-14.167 42.158-28.875 13.603-32.555 54.219-89.551-9.526-169.385-23.013-28.841-39.068-55.098-47.702-78.083-7.896-21.006-9.824-39.868-5.732-56.097.151-.621.326-1.227.501-1.848h-.588c-.15.54-.3 1.08-.438 1.62-4.13 16.408-2.19 35.467 5.769 56.636 8.672 23.05 24.752 49.389 47.827 78.279 63.532 79.589 22.891 136.274 9.426 168.519-6.056 14.51-20.109 24.097-41.746 28.514-17.356 3.534-39.605 3.779-66.122.687-45.175-5.251-87.621-18.502-88.009-18.633-.4-.213-40.77-21.349-84.968-34.715-25.728-7.787-47.74-11.435-65.46-10.912v.72c17.682-.54 39.644 3.125 65.322 10.895z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__g)",
    d: "M1.162 280.404c17.72-1.096 39.768 1.979 65.547 9.161 43.91 12.237 83.917 32.425 84.354 32.637.426.131 42.847 12.401 88.022 16.474 26.542 2.389 48.828 1.538 66.248-2.552 21.824-5.12 36.039-15.378 42.233-30.477 13.578-33.079 55.032-89.405-7.023-167.406-22.249-27.958-37.754-53.61-46.101-76.202-7.633-20.678-9.485-39.443-5.506-55.737a70 70 0 0 1 1.865-6.265h-.613a76 76 0 0 0-1.79 6.053c-4.029 16.49-2.165 35.418 5.531 56.276 8.372 22.674 23.927 48.375 46.213 76.415 61.843 77.756 20.364 133.787 6.911 166.538-6.119 14.887-20.197 25.014-41.846 30.102-17.369 4.073-39.605 4.94-66.11 2.552-45.137-4.074-87.52-16.327-87.896-16.441-.4-.197-40.444-20.401-84.392-32.654-25.816-7.198-47.928-10.29-65.685-9.177-.375.016-.738.049-1.101.081v.736l1.126-.098z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__h)",
    d: "M2.614 290.055c17.694-1.603 39.668.9 65.309 7.444 43.685 11.141 83.378 30.379 83.816 30.592.426.115 42.81 11.386 87.972 14.249 26.529 1.685 48.828.196 66.26-4.433 21.849-5.808 36.09-16.605 42.334-32.097 13.54-33.586 55.82-89.241-4.558-165.427-21.486-27.107-36.465-52.12-44.524-74.337-7.383-20.367-9.16-38.984-5.281-55.344a70 70 0 0 1 3.429-10.65h-.638a72 72 0 0 0-3.316 10.438c-3.917 16.54-2.128 35.336 5.318 55.884 8.084 22.297 23.1 47.376 44.636 74.549 60.179 75.924 17.873 131.301 4.458 164.559-6.156 15.28-20.272 25.963-41.946 31.721-17.381 4.63-39.631 6.119-66.11 4.434-45.124-2.88-87.47-14.135-87.846-14.233-.4-.196-40.131-19.451-83.854-30.592-25.69-6.544-47.715-9.063-65.46-7.46-.863.082-1.701.18-2.54.278v.736c.851-.098 1.702-.196 2.578-.278z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__i)",
    d: "M3.902 299.707c17.682-2.094 39.593-.18 65.109 5.709 43.472 10.029 82.878 28.335 83.316 28.531.425.098 42.797 10.372 87.971 12.041 26.542.981 48.854-1.162 66.298-6.348 21.861-6.511 36.14-17.864 42.434-33.749 13.49-34.077 56.571-89.077-2.156-163.463-20.747-26.273-35.201-50.649-42.972-72.489-7.133-20.04-8.847-38.526-5.08-54.935A75 75 0 0 1 303.99.035h-.651a76.3 76.3 0 0 0-5.055 14.757c-3.805 16.588-2.09 35.238 5.105 55.442 7.796 21.905 22.3 46.379 43.085 72.701 58.527 74.124 15.408 128.847 2.055 162.612-6.206 15.689-20.359 26.928-42.058 33.373-17.407 5.17-39.669 7.313-66.16 6.332-45.137-1.669-87.471-11.926-87.859-12.008-.388-.18-39.831-18.519-83.354-28.547-25.565-5.906-47.527-7.82-65.259-5.726a89 89 0 0 0-3.817.523v.736q1.896-.294 3.867-.539z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__j)",
    d: "M5.016 309.356c17.682-2.601 39.531-1.259 64.947 3.976 43.285 8.915 82.427 26.306 82.853 26.486.425.098 42.822 9.341 88.034 9.799 26.592.278 48.903-2.52 66.385-8.278 21.899-7.215 36.215-19.141 42.547-35.451 13.414-34.567 57.284-88.897.197-161.5-20.01-25.439-33.95-49.209-41.446-70.656-6.895-19.713-8.534-38.036-4.88-54.477 1.489-6.675 3.829-13.071 7.033-19.239h-.676a79.7 79.7 0 0 0-6.895 19.026c-3.692 16.605-2.04 35.108 4.905 54.984 7.534 21.53 21.511 45.365 41.571 70.869 56.887 72.358 12.98 126.393-.31 160.65-6.257 16.114-20.447 27.909-42.184 35.074-17.431 5.742-39.718 8.523-66.235 8.245-45.174-.441-87.533-9.685-87.908-9.766-.388-.18-39.569-17.57-82.904-26.503-25.465-5.251-47.364-6.592-65.096-3.975-1.69.245-3.316.54-4.93.867v.736a90 90 0 0 1 4.992-.867"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__k)",
    d: "M5.991 319.027c17.682-3.109 39.48-2.356 64.796 2.225 43.135 7.803 82.015 24.277 82.44 24.457.426.082 42.86 8.327 88.16 7.525 26.616-.458 48.991-3.91 66.497-10.224 21.95-7.918 36.303-20.433 42.672-37.169 13.327-35.025 57.973-88.701 2.5-159.537-19.284-24.621-32.736-47.786-39.969-68.824-6.657-19.386-8.234-37.545-4.693-53.986 1.752-8.163 4.756-15.967 9.01-23.443h-.688c-4.167 7.427-7.12 15.165-8.86 23.247-3.579 16.621-1.989 34.944 4.73 54.493 7.258 21.12 20.748 44.367 40.082 69.053 55.273 70.591 10.59 123.988-2.612 158.703-6.295 16.539-20.535 28.923-42.322 36.792-17.469 6.315-39.793 9.734-66.36 10.208-45.262.785-87.659-7.443-88.034-7.509-.388-.163-39.306-16.637-82.478-24.457-25.365-4.597-47.227-5.35-64.959-2.225-2.014.36-3.966.769-5.881 1.227v.736c1.94-.458 3.904-.883 5.957-1.243z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__l)",
    d: "M6.781 328.695c17.695-3.615 39.456-3.451 64.696.475 42.985 6.707 81.64 22.249 82.065 22.412.426.082 42.947 7.28 88.335 5.252 26.666-1.195 49.091-5.301 66.66-12.204 21.999-8.655 36.403-21.742 42.81-38.919 13.227-35.468 58.623-88.488 4.752-157.574-18.583-23.82-31.535-46.379-38.505-67.025-6.432-19.042-7.946-37.037-4.53-53.462 2.002-9.636 5.681-18.814 11.05-27.599h-.701c-5.268 8.736-8.885 17.848-10.875 27.419-3.466 16.605-1.927 34.764 4.555 53.953 6.996 20.727 19.997 43.353 38.63 67.254 53.684 68.84 8.237 121.583-4.864 156.739-6.332 16.981-20.611 29.954-42.459 38.543-17.52 6.887-39.894 10.977-66.511 12.171-45.337 2.029-87.834-5.169-88.209-5.218-.388-.164-39.08-15.722-82.115-22.429-25.29-3.943-47.102-4.106-64.846-.475a99 99 0 0 0-6.657 1.62v.736a99 99 0 0 1 6.744-1.636z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__m)",
    d: "M7.422 338.381c17.72-4.122 39.455-4.564 64.608-1.276 42.859 5.579 81.302 20.22 81.74 20.368.425.065 43.059 6.233 88.572 2.928 26.741-1.947 49.241-6.724 66.848-14.216 22.074-9.391 36.515-23.083 42.947-40.703 13.102-35.892 59.249-88.258 6.954-155.61-34.375-44.285-48.315-84.038-41.445-118.148 2.227-11.059 6.595-21.61 13.127-31.704h-.726c-6.419 10.044-10.712 20.514-12.939 31.524-3.341 16.572-1.865 34.535 4.392 53.381 6.745 20.335 19.259 42.355 37.203 65.47 52.108 67.123 5.923 119.195-7.067 154.777-6.369 17.439-20.71 31.001-42.621 40.326-17.57 7.476-40.019 12.236-66.711 14.183-45.475 3.305-88.059-2.863-88.447-2.912-.388-.147-38.867-14.789-81.777-20.384-25.215-3.288-47.001-2.846-64.771 1.293-2.515.589-4.93 1.259-7.283 1.996v.752c2.378-.752 4.83-1.423 7.383-2.028z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__n)",
    d: "M7.884 348.097c17.744-4.646 39.468-5.676 64.57-3.059 42.76 4.466 81.014 18.192 81.452 18.339.426.049 43.198 5.17 88.873.589 26.829-2.699 49.404-8.163 67.086-16.245 22.149-10.126 36.652-24.441 43.109-42.534 12.965-36.285 59.838-87.981 9.107-153.631-33.099-42.846-46.526-81.797-39.894-115.776 2.441-12.466 7.484-24.359 15.23-35.762h-.739C329.07 11.372 324.077 23.2 321.662 35.6c-3.229 16.523-1.802 34.273 4.23 52.776 6.494 19.925 18.545 41.356 35.801 63.687 50.543 65.405 3.632 116.822-9.219 152.813-6.395 17.897-20.785 32.081-42.785 42.142-17.631 8.065-40.156 13.529-66.935 16.212-45.625 4.58-88.36-.54-88.735-.573-.376-.131-38.68-13.873-81.49-18.355-25.164-2.634-46.938-1.603-64.72 3.059a104 104 0 0 0-7.746 2.356v.752a101 101 0 0 1 7.846-2.388z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__o)",
    d: "M8.196 357.848c17.782-5.186 39.493-6.805 64.558-4.842 42.697 3.353 80.776 16.163 81.202 16.294.425.049 43.372 4.106 89.222-1.783 26.942-3.452 49.605-9.62 67.349-18.323 22.225-10.895 36.79-25.831 43.273-44.383 12.814-36.661 60.388-87.686 11.209-151.635-31.848-41.422-44.762-79.572-38.38-113.404C329.245 25.95 334.988 12.73 343.936.02h-.764c-8.822 12.662-14.491 25.815-17.093 39.573-3.104 16.442-1.727 33.995 4.079 52.154 6.257 19.517 17.845 40.359 34.438 61.937 49.003 63.72 1.379 114.467-11.322 150.817-6.42 18.372-20.873 33.177-42.96 44.007-17.706 8.67-40.319 14.822-67.198 18.273-45.8 5.873-88.71 1.833-89.085 1.8-.376-.131-38.505-12.957-81.252-16.31-25.115-1.98-46.889-.344-64.72 4.858a103 103 0 0 0-8.035 2.683v.753c2.616-.998 5.331-1.914 8.16-2.732z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__p)",
    d: "M8.332 367.628c17.82-5.709 39.555-7.95 64.583-6.642 42.634 2.225 80.563 14.119 81.001 14.25.426.032 43.585 3.01 89.648-4.188 27.068-4.238 49.83-11.108 67.65-20.433 22.324-11.665 36.94-27.239 43.447-46.281 12.652-37.005 60.914-87.343 13.262-149.64-30.634-40.031-43.048-77.38-36.903-110.998 2.765-15.149 9.197-29.66 19.383-43.696h-.776c-10.048 13.97-16.392 28.433-19.146 43.516-2.99 16.36-1.664 33.668 3.942 51.467 6.019 19.107 17.157 39.36 33.112 60.202 47.477 62.051-.836 112.128-13.374 148.822-6.445 18.862-20.961 34.289-43.148 45.888-17.782 9.292-40.494 16.147-67.511 20.384-46.013 7.198-89.123 4.22-89.511 4.204-.375-.115-38.354-12.041-81.051-14.265-25.078-1.309-46.864.932-64.734 6.658a106 106 0 0 0-8.158 2.977v.769a109 109 0 0 1 8.296-3.026z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__q)",
    d: "M8.309 377.447c17.882-6.249 39.618-9.096 64.633-8.458 42.61 1.096 80.414 12.074 80.839 12.204.438.017 43.823 1.914 90.124-6.641 27.205-5.023 50.08-12.614 67.999-22.56 22.437-12.466 37.116-28.678 43.636-48.195 12.463-37.316 61.401-86.966 15.263-147.594-29.432-38.674-41.37-75.204-35.464-108.578 2.903-16.424 9.986-32.211 21.399-47.573h-.776c-11.262 15.296-18.283 31.034-21.173 47.41-5.944 33.635 6.031 70.394 35.614 109.248 45.963 60.399-3.013 109.788-15.376 146.793-6.458 19.353-21.049 35.434-43.348 47.818-17.87 9.93-40.695 17.505-67.862 22.511-46.251 8.539-89.598 6.658-89.986 6.642-.375-.115-38.229-11.108-80.889-12.205-25.052-.638-46.863 2.209-64.796 8.475a115 115 0 0 0-8.134 3.19v.769a107 107 0 0 1 8.272-3.256z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__r)",
    d: "M72.83 377.039h.313c42.471 0 79.987 10.029 80.413 10.143.438 0 44.086.785 90.662-9.145 27.367-5.824 50.367-14.151 68.387-24.752 22.55-13.267 37.304-30.134 43.836-50.157 12.263-37.594 61.864-86.558 17.215-145.55-28.268-37.349-39.731-73.061-34.062-106.156C342.61 33.77 350.356 16.724 362.97.02h-.764c-12.476 16.637-20.147 33.635-23.15 51.237-5.706 33.357 5.806 69.299 34.212 106.827 44.474 58.763-5.164 107.465-17.328 144.748-6.482 19.844-21.135 36.596-43.548 49.782-17.969 10.568-40.919 18.878-68.237 24.686-46.526 9.914-90.136 9.145-90.524 9.129-.375-.099-37.942-10.143-80.476-10.143h-.3c-25.065.032-46.889 3.501-64.884 10.306a113 113 0 0 0-7.92 3.337v.884c23.05-10.765 49.991-13.791 72.791-13.807z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__s)",
    d: "M72.59 385.105c42.622-1.194 80.225 7.967 80.651 8.065.438 0 44.386-.36 91.262-11.68 27.543-6.642 50.693-15.722 68.813-26.961 22.675-14.085 37.504-31.622 44.048-52.153 12.051-37.823 62.29-86.1 19.106-143.456-27.13-36.04-38.13-70.934-32.699-103.718 3.116-18.83 11.5-37.12 25.316-55.164h-.776c-13.665 17.979-21.962 36.22-25.065 55-5.469 33.03 5.581 68.153 32.848 104.373 43.01 57.143-7.267 105.142-19.23 142.67-6.495 20.368-21.211 37.791-43.761 51.778-18.069 11.222-41.17 20.269-68.662 26.911-46.827 11.304-90.737 11.664-91.125 11.664-.376-.098-38.029-9.276-80.701-8.065-25.065.703-46.94 4.793-65.009 12.171a123 123 0 0 0-7.546 3.387v.9c23.076-11.354 49.88-15.1 72.555-15.738z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__t)",
    d: "M72.217 393.216c42.646-2.356 80.188 5.906 80.613 5.988.438 0 44.724-1.522 91.926-14.266 27.73-7.476 51.043-17.308 69.263-29.217 22.825-14.904 37.717-33.145 44.261-54.199 11.826-38.019 62.691-85.576 20.957-141.362-26.016-34.763-36.577-68.84-31.371-101.28 3.378-21.055 13.177-40.637 27.28-58.862h-.914c-14.816 19.32-23.726 38.788-26.917 58.714-5.231 32.686 5.368 66.975 31.522 101.935 41.558 55.541-9.344 102.836-21.082 140.577-6.495 20.891-21.299 39.001-43.999 53.822-18.182 11.877-41.445 21.693-69.125 29.153-47.165 12.727-91.401 14.232-91.788 14.249-.376-.082-37.967-8.344-80.676-5.988-25.09 1.391-47.014 6.102-65.16 14.036A127 127 0 0 0 0 409.854v.899c23.063-11.86 49.667-16.31 72.18-17.553z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__u)",
    d: "M71.702 401.364c42.709-3.517 80.213 3.812 80.639 3.893.45-.032 45.099-2.715 92.664-16.899 27.943-8.327 51.418-18.928 69.776-31.524 22.975-15.754 37.942-34.682 44.486-56.26 11.588-38.183 63.054-85.02 22.76-139.219-24.928-33.537-35.051-66.779-30.083-98.827 3.453-22.249 13.94-43.058 29.069-62.493h-.901c-15.955 20.678-25.44 41.34-28.707 62.346-5.005 32.293 5.156 65.765 30.234 99.481 40.131 53.97-11.385 100.545-22.885 138.434-6.494 21.414-21.386 40.211-44.236 55.883-18.307 12.564-41.733 23.149-69.639 31.459-47.514 14.168-92.126 16.851-92.513 16.883-.376-.081-37.917-7.41-80.689-3.893-25.127 2.077-47.114 7.427-65.36 15.934a125 125 0 0 0-6.293 3.157v.9C23.049 408.3 49.39 403.196 71.69 401.348z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__v)",
    d: "M71.064 409.561c42.797-4.695 80.263 1.701 80.701 1.766.451-.032 45.5-3.942 93.453-19.598 28.181-9.194 51.832-20.597 70.314-33.864 23.138-16.621 38.18-36.252 44.737-58.37 11.35-38.298 63.404-84.398 24.524-137.027-23.877-32.326-33.575-64.75-28.832-96.373 3.516-23.377 14.679-45.397 30.784-66.06h-.901c-17.057 22.053-27.118 43.893-30.421 65.93-4.793 31.884 4.955 64.521 28.969 97.027 38.718 52.399-13.374 98.238-24.636 136.257-6.495 21.938-21.461 41.455-44.474 57.994-18.433 13.251-42.046 24.621-70.177 33.799-47.915 15.639-92.914 19.533-93.315 19.582-.375-.065-37.904-6.478-80.75-1.783-25.178 2.765-47.24 8.768-65.585 17.848q-2.76 1.374-5.406 2.846v.9c22.95-12.711 48.979-18.453 71.028-20.874z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__w)",
    d: "M70.287 417.822c42.897-5.89 80.376-.409 80.801-.36.451-.049 45.938-5.186 94.316-22.347 28.419-10.078 52.282-22.282 70.903-36.269 23.3-17.504 38.442-37.856 44.986-60.497 11.088-38.379 63.717-83.744 26.226-134.818-22.863-31.148-32.148-62.738-27.605-93.935 3.566-24.474 15.367-47.672 32.423-69.56h-.889c-18.132 23.41-28.719 46.411-32.072 69.429-4.58 31.426 4.755 63.245 27.743 94.573 37.328 50.862-15.339 95.965-26.339 134.066-6.494 22.477-21.548 42.714-44.736 60.12-18.583 13.955-42.384 26.126-70.765 36.187-48.341 17.145-93.778 22.282-94.166 22.331-.375-.049-37.891-5.546-80.863.36-25.24 3.468-47.39 10.126-65.848 19.795a155 155 0 0 0-4.354 2.372v.932c22.837-13.038 48.478-19.402 70.239-22.396z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__x)",
    d: "M69.361 426.114c43.035-7.1 80.526-2.552 80.951-2.503.463-.065 46.401-6.462 95.242-25.161 28.694-10.977 52.758-23.999 71.529-38.689 23.488-18.388 38.717-39.476 45.249-62.657 10.812-38.395 64.005-83.008 27.878-132.577-21.862-29.986-30.747-60.775-26.417-91.498 3.604-25.504 16.018-49.88 34-72.995h-.776c-17.832 23.066-30.158 47.393-33.75 72.864-4.367 30.952 4.568 61.953 26.555 92.12 35.964 49.34-17.254 93.691-28.003 131.824-6.482 23.034-21.636 43.991-45.012 62.281-18.733 14.658-42.747 27.647-71.39 38.624-48.791 18.682-94.692 25.079-95.092 25.144-.376-.049-37.917-4.597-81.001 2.503-25.316 4.172-47.565 11.501-66.148 21.775-1.064.589-2.09 1.194-3.128 1.799v.916c22.674-13.316 47.89-20.22 69.326-23.753z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__y)",
    d: "M68.312 434.475c43.185-8.31 80.713-4.711 81.151-4.679.463-.081 46.902-7.77 96.231-28.04 28.982-11.909 53.271-25.766 72.191-41.176 23.689-19.304 39.006-41.111 45.525-64.849 10.537-38.379 64.268-82.222 29.492-130.286-20.898-28.874-29.395-58.845-25.265-89.06 3.629-26.487 16.643-52.024 35.501-76.35h-.776c-18.72 24.277-31.647 49.765-35.276 76.218-4.167 30.462 4.38 60.628 25.403 89.683 34.625 47.851-19.143 91.432-29.604 129.533-6.47 23.574-21.712 45.267-45.287 64.489-18.884 15.394-43.135 29.218-72.067 41.111-49.279 20.253-95.667 27.942-96.08 28.008-.376-.033-37.954-3.649-81.202 4.678-25.402 4.892-47.777 12.892-66.485 23.771-.588.343-1.139.687-1.727 1.03v.9c22.462-13.513 47.202-20.924 68.275-24.997z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__z)",
    d: "M67.11 442.918c43.373-9.554 80.952-6.888 81.39-6.871.463-.082 47.44-9.113 97.282-30.985 29.282-12.859 53.809-27.566 72.905-43.712 23.901-20.221 39.305-42.797 45.812-67.074 10.262-38.33 64.518-81.372 31.056-127.963-19.959-27.795-28.081-56.947-24.139-86.64 3.642-27.418 17.232-54.067 36.928-79.62h-.776c-19.571 25.504-33.061 52.12-36.702 79.49-3.98 29.937 4.192 59.302 24.276 87.261 33.312 46.379-20.982 89.175-31.168 127.227-6.457 24.13-21.799 46.575-45.588 66.697-19.058 16.13-43.535 30.805-72.767 43.647-49.792 21.856-96.719 30.87-97.132 30.952-.375-.033-38.016-2.683-81.439 6.871C41.533 447.809 19.046 456.496.2 467.98l-.15.098v.949c22.212-13.644 46.413-21.545 67.073-26.109z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__A)",
    d: "M65.784 451.407c43.573-10.813 81.239-9.096 81.677-9.096.476-.098 48.015-10.486 98.395-33.994 29.595-13.824 54.385-29.398 73.656-46.297 24.114-21.153 39.631-44.482 46.113-69.332 9.974-38.215 64.743-80.471 32.57-125.607-19.058-26.731-26.804-55.082-23.05-84.235 3.654-28.285 17.782-56.047 38.292-82.81h-.776c-20.385 26.714-34.425 54.427-38.067 82.68-3.791 29.397 4.005 57.945 23.188 84.856 32.01 44.923-22.797 86.934-32.695 124.871-6.445 24.686-21.886 47.884-45.888 68.955-19.233 16.883-43.973 32.424-73.518 46.215-50.343 23.492-97.832 33.864-98.245 33.962-.375-.016-38.092-1.717-81.727 9.096-24.915 6.184-46.99 15.214-65.66 26.846v.916c21.912-13.726 45.525-22.036 65.747-27.058z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__B)",
    d: "M64.322 459.979c43.798-12.073 81.564-11.337 82.002-11.337.476-.114 48.616-11.893 99.584-37.087 29.946-14.805 54.986-31.262 74.444-48.931 24.352-22.117 39.969-46.198 46.426-71.588 9.686-38.052 64.943-79.507 34.047-123.219-18.183-25.717-25.578-53.25-21.987-81.846 3.654-29.104 18.308-57.945 39.606-85.92h-.763c-21.173 27.91-35.739 56.718-39.393 85.805-3.617 28.825 3.829 56.571 22.124 82.452 30.746 43.499-24.549 84.708-34.159 122.499-6.42 25.242-21.962 49.192-46.213 71.228-19.422 17.636-44.424 34.077-74.319 48.85-50.919 25.177-99.009 36.939-99.434 37.054-.376 0-38.205-.737-82.065 11.337-22.3 6.151-42.347 14.51-59.766 24.931h1.54c19.784-11.664 40.394-19.271 58.338-24.211z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__C)",
    d: "M62.705 468.619c44.049-13.366 81.94-13.611 82.378-13.611.488-.131 49.254-13.349 100.823-40.261 30.296-15.803 55.624-33.176 75.27-51.613 24.59-23.084 40.319-47.95 46.751-73.879 9.386-37.856 65.131-78.493 35.474-120.798-17.332-24.719-24.39-51.467-20.961-79.474 3.654-29.856 18.808-59.777 40.857-88.946h-.763c-21.924 29.12-36.991 58.975-40.645 88.831-3.453 28.237 3.642 55.197 21.099 80.079 29.507 42.093-26.276 82.501-35.599 120.078-6.394 25.783-22.049 50.518-46.538 73.52-19.609 18.404-44.899 35.761-75.158 51.532-51.531 26.878-100.26 40.097-100.685 40.211-.375 0-38.317.245-82.44 13.627-14.804 4.483-28.632 9.931-41.383 16.278h1.727c13.777-6.773 27.405-11.828 39.768-15.574z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__D)",
    d: "M60.965 477.355c44.336-14.658 82.366-15.901 82.804-15.918.488-.147 49.929-14.838 102.136-43.499 30.672-16.834 56.3-35.124 76.146-54.363 24.84-24.064 40.695-49.7 47.09-76.202 9.085-37.61 65.293-77.429 36.862-118.344-16.518-23.77-23.226-49.716-19.96-77.134 3.642-30.576 19.271-61.512 42.046-91.875h-.763c-22.65 30.314-38.192 61.2-41.833 91.76-3.291 27.648 3.466 53.79 20.097 77.74 28.293 40.719-27.953 80.292-36.988 117.64-6.369 26.339-22.136 51.86-46.888 75.826-19.822 19.206-45.4 37.463-76.034 54.264-52.169 28.629-101.561 43.304-101.999 43.451-.375 0-38.467 1.243-82.853 15.934a284 284 0 0 0-20.298 7.558h1.902a275 275 0 0 1 18.52-6.838z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#compliance-lines_svg__E)",
    d: "M142.342 467.898c.5-.163 50.63-16.375 103.513-46.804 31.072-17.881 57-37.119 77.072-57.143 25.115-25.063 41.083-51.483 47.452-78.525 8.797-37.316 65.456-76.301 38.214-115.858-15.717-22.837-22.112-48.014-18.996-74.828 3.629-31.23 19.722-63.163 43.185-94.704h-.764c-23.338 31.492-39.343 63.393-42.972 94.606-3.141 27.042 3.292 52.416 19.134 75.417 27.105 39.361-29.604 78.116-38.326 115.17-6.332 26.879-22.237 53.185-47.252 78.149-20.035 19.991-45.926 39.197-76.96 57.062-52.845 30.428-102.937 46.608-103.375 46.771-.376.017-36.578 2.143-79.7 16.998h2.202c42.134-14.2 77.16-16.262 77.573-16.278z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__a",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__b",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__c",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__d",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__e",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__f",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__g",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__h",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__i",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__j",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__k",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__l",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__m",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__n",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__o",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__p",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__q",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__r",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__s",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__t",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__u",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__v",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__w",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__x",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__y",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__z",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__A",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__B",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__C",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__D",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "compliance-lines_svg__E",
    x1: 359.707,
    x2: -9.501,
    y1: 242.104,
    y2: 286.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000A3",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#89D9F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4D4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3576CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D9F7",
    stopOpacity: 0
  })))));
};
export default SvgComplianceLines;